export const radius = {
  r1: '2px',
  r2: '16px',
  r3: '24px',
  rMax: '9999px',
}
